"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentOrderTypes = void 0;
var PaymentOrderTypes;
(function (PaymentOrderTypes) {
    PaymentOrderTypes["TYPE_INITIAL"] = "INITIAL";
    PaymentOrderTypes["TYPE_INITIAL_INVOICE"] = "INITIAL_INVOICE";
    PaymentOrderTypes["TYPE_INITIAL_ADDON"] = "INITIAL_ADDON";
    PaymentOrderTypes["TYPE_INITIAL_ADDON_INVOICE"] = "INITIAL_ADDON_INVOICE";
    PaymentOrderTypes["TYPE_AUTO_PAYMENT"] = "AUTO_PAYMENT";
    PaymentOrderTypes["TYPE_AUTO_PAYMENT_ADDON"] = "AUTO_PAYMENT_ADDON";
    PaymentOrderTypes["TYPE_CHANGE_CARD"] = "CHANGE_CARD";
    PaymentOrderTypes["TYPE_UMS"] = "UMS";
})(PaymentOrderTypes || (exports.PaymentOrderTypes = PaymentOrderTypes = {}));
//# sourceMappingURL=payment-order-types.enum.js.map